/** @format */

// src/components/MeetingHeader.js

const MeetingHeader = ({ meetingData, formatLongDateTime, deadlineContainerClass, isDeadlinePassed }) => {
	// Structural property key fallbacks
	const city = meetingData?.meetingCity || meetingData?.city;
	const country = meetingData?.meetingCountry;
	const venue = meetingData?.meetingVenue || meetingData?.venue;
	const organizerName = meetingData?.meetOrganiser || meetingData?.organiser;
	const registrationDeadline = meetingData?.registrationDeadline || meetingData?.deadline;

	// Combine City and Country seamlessly for clean string formatting layout structures
	const hasLocationData = city || country;
	const computedLocationString = [city, country].filter(Boolean).join(', ');

	return (
		<div className="bg-light text-dark p-2 rounded-2 mb-3 bg-opacity-75 border border-light-subtle">
			<div className="container-fluid">
				<div className="row p-0 py-md-3 gap-y-3">
					{/* ORGANISER METADATA CARD */}
					<div className="col-12 px-0 px-md-3 col-lg-6 mb-3">
						<div className="organiser-info card flex-column p-3 border border-info-subtle bg-info bg-opacity-10 text-info h-100">
							<span className="fw-semibold small text-uppercase text-dark d-block mb-1">Organiser</span>
							<p className="mb-1 small pb-0 d-flex flex-wrap align-items-center gap-2">
								<i className="fas fa-user"></i> <strong>Name:</strong> {organizerName || '—'}
							</p>
							{meetingData?.organiserEmail && (
								<p className="mb-1 small pb-0 d-flex flex-wrap align-items-center gap-2 text-break">
									<i className="fas fa-envelope"></i> <strong>Email:</strong>{' '}
									<a title={`Email ${organizerName}`} href={`mailto:${meetingData.organiserEmail}`} className="text-info text-decoration-underline link-inderline-info">
										{meetingData.organiserEmail}
									</a>
								</p>
							)}
							{meetingData?.organiserTel && (
								<p className="mb-0 small pb-0 d-flex flex-wrap align-items-center gap-2">
									<i className="fas fa-phone"></i> <strong>Tel:</strong>{' '}
									<a title={`Call ${organizerName}`} href={`tel:${meetingData.organiserTel}`} className="text-info text-decoration-underline link-inderline-info">
										{meetingData.organiserTel}
									</a>
								</p>
							)}
						</div>
					</div>

					{/* COMPETITION SCHEDULE BOUNDS */}
					<div className="col-12 px-0 px-md-3 col-lg-6 mb-3">
						<div className="meet-schedule card flex-column p-3 border border-info-subtle bg-info bg-opacity-10 text-info h-100">
							<span className="fw-semibold small text-uppercase text-dark d-block mb-1">Schedule</span>
							<p className="mb-1 small pb-0 d-flex align-items-center gap-2">
								<i className="fas fa-calendar-alt"></i> <strong>Starts:</strong> {formatLongDateTime(meetingData?.dateTime)}
							</p>
							<p className="mb-0 small pb-0 d-flex align-items-center gap-2">
								<i className="fas fa-calendar-check"></i> <strong>Ends:</strong> {formatLongDateTime(meetingData?.endDateTime)}
							</p>
						</div>
					</div>

					{/* PHYSICAL VENUE LOCATION HOVER */}
					<div className="col-12 px-0 px-md-3 col-lg-6 mb-3 mb-lg-0">
						<div className="venue-info card flex-column p-3 border border-info-subtle bg-info bg-opacity-10 text-info h-100">
							<span className="fw-semibold small text-dark text-uppercase d-block mb-1">Location</span>
							<p className="mb-0 small d-flex align-items-start gap-2">
								<i className="fas fa-map-marker-alt mt-1"></i>
								<span>
									<strong>{venue || 'Main Stadium'}</strong>
									{hasLocationData && <span className="d-block text-opacity-75 small mt-1">{computedLocationString}</span>}
								</span>
							</p>
						</div>
					</div>

					{/* ENTRY RECONCILIATION DEADLINE COUNTER */}
					<div className="col-12 px-0 px-md-3 col-lg-6">
						<div className={deadlineContainerClass}>
							<span className="fw-semibold small text-uppercase text-light d-block mb-1">Registration</span>
							<p className="mb-1 small pb-0 d-flex align-items-center gap-2">
								<i className="fas fa-hourglass-half"></i> <strong>Deadline:</strong> {formatLongDateTime(registrationDeadline)}
							</p>
							<p className="mb-0 small fw-bold">{isDeadlinePassed ? '⚠️ Entries are Closed' : '🟢 Accepting Entries'}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MeetingHeader;
